export default "__VITE_ASSET__DyjehE7$__"